import { isValid } from 'date-fns';
import React from 'react';

import FormattedDateTime from '../FormattedDateTime/FormattedDateTime';
import type { DateTimeOptions } from '../FormattedDateTime/FormattedDateTime';

interface Props {
  eventStartDate: string | number;
  weekdayFormat?: DateTimeOptions['weekday'];
}

const BetDate: React.FC<Props> = ({ eventStartDate, weekdayFormat = 'short' }) => {
  const eventDate = new Date(eventStartDate);

  if (!isValid(eventDate)) return null;

  return <FormattedDateTime date={eventStartDate} format="long" weekday={weekdayFormat} />;
};

export default BetDate;
